import { Icon } from "semantic-ui-react";

import React from "react";

import themeColors from "../../constants/themeColors";

import Button from "../Buttons/Button";

export default function CardContentExpandButton({ expand, onClick }) {
	if (!expand) {
		return false;
	}

	return (
		<Button
			icon
			circular
			size="mini"
			style={{
				width: 60,
				padding: 0,
				margin: "-9px auto",
				position: "relative",
				lineHeight: "15px",
				color: themeColors.GREY,
				backgroundColor: "var(--color-bg-body)",
				border: `1px solid ${themeColors.BORDER}`,
			}}
			onClick={onClick}
		>
			<Icon link name={"chevron up"} />
		</Button>
	);
}
